import { render, staticRenderFns } from "./refer.vue?vue&type=template&id=2629e8b4"
import script from "./refer.vue?vue&type=script&lang=js"
export * from "./refer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports